import { render, staticRenderFns } from "./BsRipple.vue?vue&type=template&id=72d2de28&scoped=true&"
import script from "./BsRipple.vue?vue&type=script&lang=js&"
export * from "./BsRipple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2de28",
  null
  
)

export default component.exports